export const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    backgroundImage: `url(${require("../../../assets/images/bg-img-5.jpg")})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    padding: "20px",
  },
  logoContainer: {
    display: "flex",
    justifyContent: "center",
    margin: "20px",
  },
  logo: {
    width: "150px",
    height: "auto",
    maxWidth: "100%",
  },
  forgotPasswordCard: {
    width: "100%",
    maxWidth: 350,
    margin: "0 auto",
  },
  forgotPasswordButton: {
    width: "100%",
    marginBottom: 5,
  },
  copyright: {
    marginTop: "20px",
    textAlign: "center" as const,
  },
  loginText: {
    marginTop: 10,
    textAlign: "center" as const,
  },
};
